<template>
  <div>
    <div class="header">
      <div
        class="header_back"
        v-if="has_back"
      >
        <img
          class="back_img"
          src="../assets/back.png"
          v-on:click="$router.go(-1)"
        >
      </div>

      <img
        src="../assets/header-logo.png"
        class="my-title"
        v-on:click="$router.push('/')"
      >

      <div
        class="version"
        @click="reload()"
      >
        ver 0.3.43
      </div>

    </div>

    <!-- サイドメニューが表示の通常画面を薄暗くする -->
    <div
      id="background-sidemenu"
      v-if="show_sidemenu"
    ></div>

    <!-- 薄暗い部分を押すとサイドメニューが非表示になる -->
    <div
      id="close-sidemenu"
      v-if="show_sidemenu"
      v-on:click="show_sidemenu = false;"
    ></div>

    <div id="navmenu">
      <transition>
        <div
          class="sidemenu"
          v-if="show_sidemenu"
        >
          <v-btn v-on:click="$router.push('registration')">
            ログイン</v-btn>
          <v-btn v-on:click="Logout">
            ログアウト</v-btn>
          <v-btn>お気に入りリスト</v-btn>
          <v-btn>閲覧履歴</v-btn>
          <v-btn v-on:click="$router.push('writeReview')">レビューを書く</v-btn>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import firebase from "firebase";
export default {
  props: ["has_back"],
  data() {
    return { show_sidemenu: false };
  },
  methods: {
    reload() {
      window.location.reload(true);
    },
    Logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          alert("Logout!");
          this.$router.push("/");
        })
        .catch(error => {
          alert(error.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  top: 0;
  left: 0;
  width: 100%;
  height: 9vh;
  background-color: #fffde4;
  border-bottom: solid 1px rgb(190, 190, 190);
  .header_back {
    display: inline-block;
    margin: 1vh 0 0 2vw;
    text-align: center;
    width: 15vw;
    height: 7vh;
    line-height: 7vh;
    border-radius: 20px;
    box-shadow: 0 1px 1px rgb(190, 190, 190);
    background-color: white;
    .back_img {
      display: inline-block;
      height: 2vh;
    }
  }
  .my-title {
    position: absolute;
    top: 1vh;
    left: 0;
    right: 0;
    margin: auto;
    width: 35vw;
  }
  .version {
    position: absolute;
    top: 5vh;
    left: 0;
    right: 0;
    margin-left: auto;
    width: 20vw;
  }
}
.sidemenu {
  background-color: rgba(255, 255, 255, 0.99);
  height: 100%;
  position: fixed;
  width: 40vw;
  top: 0;
  right: 0;
  /* これがないとimgタグ画像が上に来てしまう */
  z-index: 1;
  div {
    color: black;
  }
}

/* 開く前と閉じた後の横のサイズを0にすることで横からにゅっと出る（ように見えるようになる） */
.v-enter,
.v-leave-to {
  width: 0;
}
/* v-ifの表示・非表示の瞬間だけVueの方で自動的に付与されるクラス */
.v-enter-active,
.v-leave-active {
  transition: 0.3s;
}

#background-sidemenu {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
#close-sidemenu {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 60vw;
  height: 100%;
}
</style>
